import { BottomSheet, navigationRef } from '@bonanza-social/navigation';
import {
  startListening,
  isAnyOf,
  verifyIdentity,
} from '@bonanza-social/toolkit/state';
import {
  getAccount,
  setAccount,
  selectAccount,
} from '@bonanza-social/account/state';
import {
  getWelcomePromos,
  selectWelcomePromosState,
} from '@bonanza-social/promos/state';

import { getOnboardingStep } from './onboarding.utils';

startListening({
  matcher: isAnyOf(verifyIdentity, getAccount.fulfilled, setAccount),
  effect: async (_, { getState, condition, cancelActiveListeners }) => {
    cancelActiveListeners();

    const welcomePromosState = selectWelcomePromosState(getState());

    if (welcomePromosState === 'idle' || welcomePromosState === 'pending') {
      await condition(getWelcomePromos.fulfilled.match);
    }

    const account = selectAccount(getState());

    if (!account) {
      return;
    }

    const { status, statusReason, verificationMeta } = account;

    if (statusReason === 'KYC Address Mismatch') {
      navigationRef.navigate('AddressVerificationScreen');

      return;
    }

    const onboardingStep = await getOnboardingStep({
      status,
      statusReason,
      verificationMeta,
    });

    const currentRouteName = navigationRef?.current?.getCurrentRoute()?.name;

    if (onboardingStep && currentRouteName !== 'PaymentStatusScreen') {
      BottomSheet.open({
        namespace: 'onboarding',
        type: 'Onboarding',
        titleKey: `${onboardingStep}Title`,
        titleNS: 'onboarding',
        replace: true,
        data: {
          step: onboardingStep,
        },
      });
    }
  },
});
